import type { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { ScheduleListParams } from '../api/schedules-api';
import { SCHEDULE_FILTER_FIELDS, SCHEDULE_SORTS } from '../components/schedule-filters';

/** URL search params of the schedules list; mirrors GET /admin/v1/org/schedules. */
export const scheduleListSearchSchema = indexSearchSchema(SCHEDULE_FILTER_FIELDS, {
  sort: SCHEDULE_SORTS,
});

export type ScheduleListSearch = z.infer<typeof scheduleListSearchSchema>;

export function scheduleListParams(search: ScheduleListSearch): ScheduleListParams {
  return listParams(search, SCHEDULE_FILTER_FIELDS);
}
